import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import HomePageLoaderContext from '@tcp/core/src/components/common/molecules/PageSlots/HomePageLoaderContext';

class HomePageLoadingComponent extends PureComponent {
  render() {
    const { hideOneColumn } = this.props;
    return (
      <HomePageLoaderContext.Consumer>
        {(loadingParam) => (loadingParam ? <div>{loadingParam(hideOneColumn)}</div> : <></>)}
      </HomePageLoaderContext.Consumer>
    );
  }
}

HomePageLoadingComponent.propTypes = {
  hideOneColumn: PropTypes.bool,
};
HomePageLoadingComponent.defaultProps = {
  hideOneColumn: false,
};
export default HomePageLoadingComponent;
